// extracted by mini-css-extract-plugin
export default {"default_button":"styles_default_button__RZ1AS","second_button":"styles_second_button__Q2j9g"};